import React, {
  forwardRef,
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from 'react';
import {
  Button,
  Grid,
  makeStyles,
  Tooltip,
  Typography,
} from '@material-ui/core';
import clsx from 'clsx';
import InfoIcon from '@material-ui/icons/Info';
import { getBillingInfo } from 'controllers/billing';

const useStyles = makeStyles(() => ({
  bannerContainer: {
    background: '#fff',
    padding: 24,
    borderRadius: 2,
    minHeight: 120,
    position: 'relative',
  },
  bannerContent: {
    maxWidth: 758,
  },
  title: {
    fontSize: 24,
    fontWeight: 'normal',
    lineHeight: 1.33,
    color: 'rgba(0, 0, 0, 0.87)',
    marginBottom: 6,
  },
  subTitle: {
    fontSize: 13,
    fontWeight: 'normal',
    lineHeight: 1.54,
    letterSpacing: '0.24px',
    color: '#60676f',
  },
  img: {
    position: 'absolute',
    right: 10,
    bottom: 0,
  },
  apiCountContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 8,
  },
  apiCountText: {
    padding: '0 5px 0 12px',
    fontFamily: 'Roboto',
    fontSize: 13,
    fontWeight: 'normal',
    fontStyle: 'normal',
    letterSpacing: 0.24,
    color: '#4b8c6f',
  },
}));

const SrPageBanner = forwardRef(
  ({
    title,
    subTitle,
    image,
    xs = 12,
    containerClass = '',
    planId = '',
    apiLink = '',
    bannerRef,
  }) => {
    const classes = useStyles();

    const [credits, setCredits] = useState({
      availableCredit: 0,
      totalCredit: 0,
    });

    const getCreditCount = useCallback(async () => {
      const creditResponse = await getBillingInfo(planId);
      setCredits(
        creditResponse || {
          availableCredit: 0,
          totalCredit: 0,
        }
      );
    }, [planId]);

    useLayoutEffect(() => {
      if (bannerRef) {
        bannerRef.current = { getCreditCount };
      }
    }, [bannerRef, getCreditCount]);

    useEffect(() => {
      getCreditCount();

      return () => {
        setCredits({
          availableCredit: 0,
          totalCredit: 0,
        });
      };
    }, [planId, getCreditCount]);

    return (
      <Grid
        item
        xs={xs}
        classes={{ root: clsx(classes.bannerContainer, containerClass) }}
      >
        <div className={classes.bannerContent}>
          <Typography classes={{ root: classes.title }}>{title}</Typography>
          <Typography classes={{ root: classes.subTitle }}>
            {subTitle}
          </Typography>
          <div className={classes.apiCountContainer}>
            <Button
              color="primary"
              variant="contained"
              onClick={() => window.open(apiLink, '_blank', 'noreferrer')}
            >
              API Docs
            </Button>
            <Typography classes={{ root: classes.apiCountText }}>
              {credits.totalCredit - credits.availableCredit} /{' '}
              {credits.totalCredit}
            </Typography>
            <Tooltip title="Used Credits / Total Credits">
              <InfoIcon color="primary" />
            </Tooltip>
          </div>
        </div>
        <img src={image} alt={title} className={classes.img} />
      </Grid>
    );
  }
);

export default SrPageBanner;
